import { useEffect, useState } from "react";
import placeholderimg from "../styles/img/placeholder.jpg";
import { TbCircle, TbCircleCheck } from "react-icons/tb";
const Card = ({
  enabled,
  name,
  description,
  tenantColor,
  image,
  slug,
  finished,
}) => {
  const [token, setToken] = useState(null);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const urlSearchParams = new URLSearchParams(window.location.search);
      setToken(urlSearchParams.get("token"));
    }
  }, []);

  const handleRedirect = () => {
    if (!token) return;

    switch (slug) {
      case "InsuranceVerification":
        window.location.href = `/insurance?token=${token}`;
        break;
      case "DocAuth":
        window.location.href = `/auth?token=${token}`;
        break;
      case "DocAuthBasic":
        window.location.href = `/auth?token=${token}`;
        break;
      case "FileUpload":
        window.location.href = `/capture?token=${token}`;
        break;
      case "IncomeVerification":
        window.location.href = `/income?token=${token}`;
        break;
      case "RiskAnalysis":
        window.location.href = `/riskAnalysis?token=${token}`;
        break;
      case "ComplianceCheck":
        window.location.href = `/complianceCheck?token=${token}`;
        break;
      case "FaceMatchCheck":
        window.location.href = `/selfie?token=${token}`;
        break;
      case "DocAuth2":
        window.location.href = `/scan?token=${token}`;
        break;
      default:
        window.location.href = `/setup?token=${token}`;
        break;
    }
  };

  return (
    <button
      onClick={() => {
        if (!finished && enabled) {
          handleRedirect();
        }
      }}
      className={`w-full p-2.5 border border-[#B1B0B3] rounded-md bg-white flex gap-2 items-center justify-between ${finished || !enabled
        ? "cursor-not-allowed opacity-50"
        : "cursor-pointer hover:bg-gray-50"
        }`}
    >
      <div className="flex justify-start items-start gap-2 w-full">
        <img
          src={image ? `data:image/png;base64,${image}` : placeholderimg}
          alt=""
          className="w-[30px] h-[30px] rounded"
          width={30}
          height={30}
        />
        <div className="flex flex-col gap-1 items-start text-start justify-start w-full">
          <h2 className="text-[#333333] font-bold text-base">{name || "-"}</h2>
          <p className="text-[#333333] text-xs text-start">
            {description || "-"}
          </p>
        </div>
      </div>
      <div className="flex items-center justify-center gap-1">
        {finished ? (
          <TbCircleCheck
            className="w-[23px] h-[23px] opacity-75"
            style={{ color: tenantColor }}
          />
        ) : (
          <TbCircle className="w-[23px] h-[23px] text-secundary-grey" />
        )}
      </div>
    </button>
  );
};

export default Card;
